import { render, staticRenderFns } from "./CalendarioDia.vue?vue&type=template&id=453ab564&scoped=true"
import script from "./CalendarioDia.vue?vue&type=script&lang=js"
export * from "./CalendarioDia.vue?vue&type=script&lang=js"
import style0 from "./CalendarioDia.vue?vue&type=style&index=0&id=453ab564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453ab564",
  null
  
)

export default component.exports